<template>
    <section class="row hashtag-stats">
        <div class="gauge-wrapper col-md-5">
            <img class="gauge" :src="image">
            <br>
            <p>
                <strong>RiteTag Recommendation:</strong>
                <br>
                {{description}}
            </p>
            <p v-if="!data.instagram" class="text-success"><i class="fa fa-check"></i> #{{data.hashtag}} is not banned on Instagram</p>
            <p v-if="data.instagram" class="text-danger"><i class="fa fa-times"></i> #{{data.hashtag}} is banned on Instagram</p>
        </div>
        <div class="col-md-6 col-md-offset-1">
            <div class="circleStatsWrapper">
                <div class="bigCircle">
                    <span class="value">{{data.tweets | round(2)}}</span>
                </div>
                <div class="smallCircle"><i class="fa fa-twitter"></i></div>
                <div class="text">unique tweets</div>
                <div class="unit">per hour</div>
            </div>
            <div class="circleStatsWrapper">
                <div class="bigCircle">
                    <span class="value">{{data.exposure | formatBigNumbers(1)}}</span>
                </div>
                <div class="smallCircle"><i class="fa fa-eye"></i></div>
                <div class="text">hashtag exposure</div>
                <div class="unit">per hour</div>
            </div>
            <div class="circleStatsWrapper">
                <div class="bigCircle">
                    <span class="value">{{data.retweets | round(2)}}</span>
                </div>
                <div class="smallCircle"><i class="fa fa-retweet"></i></div>
                <div class="text">retweets</div>
                <div class="unit">per hour</div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'HashtagStats',
        props: ['data'],
        computed: {
            image () {
                switch (this.data.color) {
                case 1:
                    return 'https://cdn.ritekit.com/assets/img/ritetag/gauge-overused.svg'
                case 2:
                    return 'https://cdn.ritekit.com/assets/img/ritetag/gauge-longlife.svg'
                case 3:
                    return 'https://cdn.ritekit.com/assets/img/ritetag/gauge-hot.svg'
                default:
                    return 'https://cdn.ritekit.com/assets/img/ritetag/gauge-underused.svg'
                }
            },
            description () {
                switch (this.data.color) {
                case 1:
                    return 'Do not use this hashtag, your tweets will disappear in the crowd'
                case 2:
                    return 'Use this hashtag to get seen over time'
                case 3:
                    return 'Use this hashtag to get seen now'
                default:
                    return 'Do not use this hashtag, very few people are following it'
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .hashtag-stats {
        .gauge-wrapper {
            text-align: center;
            .gauge {
                display: inline-block;
                max-width: 350px;
                margin-top: 20px;
                margin-bottom: 10px;
            }
        }
        &.loading-animation {
                -webkit-filter: grayscale(100%);
                filter: grayscale(100%);
                pointer-events: none;
                animation-name: blink;
                animation-duration: 2s;
                animation-timing-function: ease-out;
                animation-iteration-count: infinite;

                .value, p {
                    background-color: #e0e0e0;
                    color: #e0e0e0;
                    border-color: #e0e0e0;
                }
            }
    }

    .circleStatsWrapper {
        display: inline-block;
        margin: 0 25px
    }
    .circleStatsWrapper {
        position: relative;
        font-family: "Lato", sans-serif;
        font-weight: 600;
    }
    @media screen and (max-width: 385px) {
        .circleStatsWrapper {
            display: block;
            margin: 0 auto 20px;
        }
    }
    .circleStatsWrapper .bigCircle {
        width: 100px;
        height: 100px;
        text-align: center;
        background-color: #fff;
        border: 10px solid #55acee;
        border-radius: 60px;
    }
    @media screen and (max-width: 385px) {
        .circleStatsWrapper .bigCircle {margin: auto;}
    }
    .circleStatsWrapper .value {
        display: inline-block;
        padding-top: 0px;
        margin-top: 30px;
        font-size: 20pt;
        color: #4f4f4f;
        min-height: 38px;
        min-width: 40px;
    }
    .circleStatsWrapper .smallCircle {
        position: absolute;
        top: 93px;
        left: 39px;
        z-index: 2;
        width: 38px;
        height: 38px;
        font-size: 14pt;
        text-align: center;
        background-color: #fff;
        color: #808080;
        border: 1px solid #c0c0c0;
        border-radius: 20px;
    }
    @media screen and (max-width: 385px) {
        .circleStatsWrapper .smallCircle {left: 45%;}
    }
    .circleStatsWrapper .smallCircle i {margin-top: 9px;}
    .circleStatsWrapper .text {
        margin-top: 15px;
        text-align: center;
    }
    .circleStatsWrapper .unit {
        font-size: 9pt;
        text-align: center;
        color: gray;
    }
    .circleStatsWrapper .bigCircle {
        margin: auto;
        width: 120px;
        height: 120px;
    }
    .circleStatsWrapper .smallCircle {
        right: 0;
        left: 0;
        margin: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/HashtagStats.vue